/**
 * UI-side mirror of the `admin-actions` bot's `edit-members` authorization policy:
 * editing your own Practitioner profile requires `can_edit_own_profile`, editing
 * another member's requires `edit_users`. Role capability (provider/supervisor) is
 * deliberately irrelevant — non-clinical staff own editable profiles too.
 */

import type { UserPermissions } from '../../pages/users/types/permissions';

export function canEditMemberProfile(
  permissions: Partial<UserPermissions>,
  isSelf: boolean,
): boolean {
  return isSelf ? permissions.can_edit_own_profile === true : permissions.edit_users === true;
}
